import Phaser from 'phaser';

export interface BackHandler {
  handleBack(): void;
}

let gameRef: Phaser.Game | null = null;
let handlingPopState = false;

function onPopState(): void {
  if (!gameRef) {
    history.pushState({ lithoform: true }, '');
    return;
  }

  const scenes = gameRef.scene.getScenes(true).filter(s => {
    return 'handleBack' in s && typeof (s as unknown as BackHandler).handleBack === 'function';
  });
  const activeScene = scenes[scenes.length - 1];

  if (activeScene) {
    const handler = activeScene as unknown as BackHandler;
    handlingPopState = true;
    handler.handleBack();
    if (handlingPopState) {
      history.pushState({ lithoform: true }, '');
      handlingPopState = false;
    }
  } else {
    history.pushState({ lithoform: true }, '');
  }
}

export function pushSceneState(): void {
  if (handlingPopState) {
    handlingPopState = false;
    return;
  }
  history.pushState({ lithoform: true }, '');
}

export function initBackButton(game: Phaser.Game): void {
  gameRef = game;
  history.replaceState({ lithoform: true }, '');
  history.pushState({ lithoform: true }, '');
  window.addEventListener('popstate', onPopState);
}
